export abstract class ActivityHelper {
  private static readonly INACTIVE_TIMEOUT = 300_000; // 300_000ms = 5 minutes
  private static lastUserActivity = new Date();

  public static init(): void {
    window.removeEventListener('resize', ActivityHelper.handleActivity);
    document.removeEventListener('scroll', ActivityHelper.handleActivity);
    document.removeEventListener('visibilitychange', ActivityHelper.handleActivity);
    document.removeEventListener('keydown', ActivityHelper.handleActivity);
    document.removeEventListener('click', ActivityHelper.handleActivity);
    document.removeEventListener('mousemove', ActivityHelper.handleActivity);

    window.addEventListener('resize', ActivityHelper.handleActivity);
    document.addEventListener('scroll', ActivityHelper.handleActivity);
    document.addEventListener('visibilitychange', ActivityHelper.handleActivity);
    document.addEventListener('keydown', ActivityHelper.handleActivity);
    document.addEventListener('click', ActivityHelper.handleActivity);
    document.addEventListener('mousemove', ActivityHelper.handleActivity);
  }

  private static handleActivity = () => {
    ActivityHelper.lastUserActivity = new Date();
  };

  public static isInactive(): boolean {
    const inactiveAt = ActivityHelper.lastUserActivity.getTime() + ActivityHelper.INACTIVE_TIMEOUT;
    const now = new Date().getTime();
    return inactiveAt < now;
  }
}
